import { ApolloError, gql, useMutation } from "@apollo/client";
import {
  CrPortInput,
  CrPortMutation,
  CrPortMutationVariables,
} from "../generated/graphql";
import { CouponScopeEnum, CouponStatusEnum } from "../constants/enum";

const EDIT_COUPON_MUTAION = gql`
  mutation editCoupon($input: EditCouponInput!) {
    editCoupon(input: $input) {
      ok
      err
    }
  }
`;

export interface EditCouponMutation {
  editCoupon: {
    ok: boolean;
    err: string;
  };
}

export interface EditCouponInput {
  couponId: number;
  name: string;
  scope: CouponScopeEnum;
  status: CouponStatusEnum;
  code?: string;
  validFrom?: string;
  validUntil?: string;
  description?: string;
  usageLimit: number;
  userUsageLimit?: number;
  linkServiceId?: number;
  corporationId?: number;
  discountPrice: number;
}

export interface EditCouponVariables {
  input: EditCouponInput;
}

export const useEditCoupon = (
  onCompleted?: (data: EditCouponMutation) => void,
  onError?: (error: ApolloError) => void
) => {
  return useMutation<EditCouponMutation, EditCouponVariables>(
    EDIT_COUPON_MUTAION,
    {
      onCompleted,
      onError,
    }
  );
};
